export default __webpack_public_path__ + "static/media/frmlogo.476239fa.png";